// @flow
import Spot from 'common/modules/spots/domain/Spot';
import {
  ADD_SPOTS,
  ADD_SPOTS_FAILED,
  ADD_SPOTS_SUCCESS,
  DELETE_SPOTS,
  DELETE_SPOTS_FAILED,
  DELETE_SPOTS_SUCCESS,
  FETCH_SPOTS,
  FETCH_SPOTS_FAILED,
  FETCH_SPOTS_SUCCESS,
  UPDATE_SPOTS,
  UPDATE_SPOTS_FAILED,
  UPDATE_SPOTS_SUCCESS,
} from '../actions/spotActions';

export type AddSpotsState = {
  adding: boolean;
};

export type UpdateSpotsState = {
  updating: boolean;
};

export type DeleteSpotsState = {
  deleting: boolean;
};

export type SpotsState = {
  fetching: boolean;
  spots: Spot[];
  error: ?Object;
  addSpots: AddSpotsState;
  updateSpots: UpdateSpotsState;
  deleteSpots: DeleteSpotsState;
};

export const initialState: SpotsState = {
  fetching: false,
  spots: [],
  error: null,
  addSpots: {
    adding: false,
  },
  updateSpots: {
    updating: false,
  },
  deleteSpots: {
    deleting: false,
  },
};

const hasSpot = (spots: Spot[], spot: Spot): boolean => Boolean(spots.find(compared => spot.isSameAs(compared)));
export default (state: SpotsState = initialState, action: any) => {
  switch (action.type) {
    case ADD_SPOTS: {
      return {
        ...state,
        addSpots: { adding: true },
      };
    }
    case ADD_SPOTS_SUCCESS: {
      const spots: Array<Spot> = state.spots.slice().concat(action.spots);
      return {
        ...state,
        spots,
        addSpots: { adding: false },
      };
    }
    case ADD_SPOTS_FAILED: {
      return {
        ...state,
        addSpots: { adding: false },
      };
    }
    case UPDATE_SPOTS: {
      return {
        ...state,
        updateSpots: { updating: true },
      };
    }
    case UPDATE_SPOTS_SUCCESS: {
      const spots: Array<Spot> = state.spots.slice();
      action.spots.forEach((spot) => {
        const index = spots.findIndex(compared => compared.isSameAs(spot));
        spots[index] = spot;
      });

      return {
        ...state,
        spots,
        updateSpots: { updating: false },
      };
    }
    case UPDATE_SPOTS_FAILED: {
      return {
        ...state,
        updateSpots: { updating: false },
      };
    }
    case DELETE_SPOTS: {
      return {
        ...state,
        deleteSpots: { deleting: true },
      };
    }
    case DELETE_SPOTS_SUCCESS: {
      const spots = state.spots.filter(spot => !hasSpot(action.spots, spot));

      return {
        ...state,
        spots,
        deleteSpots: { deleting: false },
      };
    }
    case DELETE_SPOTS_FAILED: {
      return {
        ...state,
        deleteSpots: { deleting: false },
      };
    }
    case FETCH_SPOTS: {
      return {
        ...state,
        fetching: true,
        error: undefined,
        spots: [],
      };
    }
    case FETCH_SPOTS_SUCCESS: {
      return {
        ...state,
        fetching: false,
        error: undefined,
        spots: action.spots,
      };
    }
    case FETCH_SPOTS_FAILED: {
      return {
        ...state,
        fetching: false,
        error: action.error,
        spots: [],
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/spots/reducers/spotReducer.js